var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLockRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 0A20 20 0 0 0 0 20a20 20 0 0 0 20 20 20 20 0 0 0 20-20A20 20 0 0 0 20 0zm0 10a5.841 5.841 0 0 1 5.834 5.834V17.5h1.25c.23 0 .416.186.416.416v10.418c0 .92-.747 1.666-1.666 1.666H14.166c-.92 0-1.666-.747-1.666-1.666V17.916c0-.23.186-.416.416-.416h1.25v-1.666A5.841 5.841 0 0 1 20 10zm0 2.5a3.338 3.338 0 0 0-3.334 3.334V17.5h6.668v-1.666A3.338 3.338 0 0 0 20 12.5zm0 8.334c-.92 0-1.666.747-1.666 1.666 0 .539.255 1.03.682 1.34l-.264 2.363a.418.418 0 0 0 .414.463h1.668a.417.417 0 0 0 .414-.463l-.264-2.363c.427-.31.682-.801.682-1.34 0-.92-.747-1.666-1.666-1.666z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLockRound);
export default __webpack_public_path__ + "static/media/ic_lock_round.7665426e2def57bef53325004f701d29.svg";
export { ForwardRef as ReactComponent };